'use client'

import { Language } from '@/types/language.types'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '../ui/breadcrumb'
import { House } from 'lucide-react'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { Fragment } from 'react'

export interface BreadcrumbItemType {
  doc?: number | object | null
  url?: string | null
  label?: string | null
  id?: string | null
}

interface Props {
  breadcrumbs: BreadcrumbItemType[]
  locale: Language
}

const PageBreadcrumbs = ({ breadcrumbs, locale }: Props) => {
  const t = useTranslations()

  if (!breadcrumbs || breadcrumbs.length === 0) return null

  return (
    <div>
      <Breadcrumb aria-label={t('breadcrumb')} className='py-2 border-b bg-white'>
        <BreadcrumbList className='container-max mx-auto px-4 flex items-center '>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link href='/'>
                <House className='size-4' aria-hidden='true' />
                <span className='sr-only'>{t('home')}</span>
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>

          {breadcrumbs.map((crumb, index) => (
            <Fragment key={crumb.id + '-' + index}>
              <BreadcrumbSeparator />
              {crumb.url && (
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link href={'/' + locale + crumb.url} className='capitalize'>
                      {crumb.label}
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
              )}
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  )
}

export default PageBreadcrumbs
